var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsWalk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 16 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-walk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-walk",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.369,
    cy: 3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.029,10.8 L12.929,10.432 C12.3666575,10.2450007 11.8381922,9.96844275 11.364,9.613 L10.348,8.85 C8.62231958,7.55682346 6.31459739,7.34822673 4.385,8.311 L4.385,8.311 C2.26201229,9.36163807 0.905064487,11.5115221 0.87,13.88 C0.837313778,14.6017419 1.30510355,15.251266 2,15.449 C2.43621561,15.5593089 2.89890984,15.4679734 3.26048841,15.2001804 C3.62206698,14.9323875 3.84433536,14.5164249 3.866,14.067 C3.86471684,12.7988804 4.55471117,11.6308733 5.666,11.02 L5.866,10.92 L5.866,12.694 C5.86614276,14.112688 5.7108835,15.5271233 5.403,16.912 L5.403,16.912 C4.99046522,18.4443851 4.23473004,19.8628419 3.193,21.06 C2.67688992,21.7081062 2.78389387,22.6518899 3.43200001,23.168 C4.08010616,23.6841101 5.0238899,23.5771061 5.54,22.929 C6.75981239,21.3889977 7.67266313,19.6291546 8.229,17.745 C9.46545103,19.1036403 10.3924359,20.714349 10.946,22.466 C11.1100445,22.9811462 11.5386116,23.3681587 12.0677632,23.4789953 C12.5969149,23.5898318 13.1447705,23.4073416 13.5017611,23.0013319 C13.8587517,22.5953222 13.9696368,22.0286186 13.792,21.518 C12.9406602,18.8195558 11.3597408,16.4090689 9.224,14.553 C9.00075631,14.3663676 8.87092251,14.0909737 8.869,13.8 L8.869,11.492 L9.56,12.01 C10.2924755,12.5598468 11.1090032,12.9876965 11.978,13.277 L13.154,13.669 C13.5743013,13.8095166 14.0352267,13.756985 14.4131307,13.5254971 C14.7910347,13.2940092 15.0472333,12.9072611 15.113,12.469 C15.2024308,11.7238194 14.746157,11.0213093 14.029,10.8 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWalk);
export default __webpack_public_path__ + "static/media/icons-walk.c6de6193bf1ee75562753ccb1a625727.svg";
export { ForwardRef as ReactComponent };